//首页
export const h = {
    lang: "中文",
    solution: "Solution",
    isp: "ISP",
    enterprise: "Enterprise",
    product: "Product",
    csa: "Cloud SaaS Acceleration",
    cxc: "Cloud Xpress Connect",
    vn: "Virtual Network",
    mobility: "Mobility",
    hardware: "Hardware",
    gaa: "Global App Access",
    customer: "Customer",
    ccs: "Customer Case Study",
    Financial: "Financial",
    Energy: "Energy",
    Education: " Education",
    technology: "Technology",
    wp: "Document",
    download: "Download",
    Support: "Support",
    cooperation: "Cooperation",
    aboutUs: "About Us",
    overview: "Overview",
    et: "Expert Team",
    awards: "Awards",
    news: "News",
    //home
    ban1: "High Performance",
    ban2: "Strong Security",
    ban3: "Flexible Deployment",

    we: "We are a pioneer of SD-WAN service solution provider",
    wec:
        "We build advanced, stable, high speed, low latency WAN networks to help enterprise users focus on their core business.",

    what: "What is SD-WAN",
    whatc: "Software-Defined Network",
    whatc1: "Global Deployment",
    whatc2: "Enterprise Network Connection",

    why: "Software-Defined Network",
    whyc: "High Performance Data Transmission",
    whyc1: "Strong Security",
    whyc2: "Flexible Deployment",

    di: "Global Deployment",
    dic: "Global SaaS Acceleration",
    dic1: "Protecting Application Data",
    dic2: "Flexible Deployment",

    xian: "Enterprise Network Connection",
    xianc: "Enterprise Global Private Network",
    xianc1: "Enterprise Data Acceleration",
    xianc2: "Secured Data Channel",

    new: "News",
    more: "More",
    About: "Video introduction",

    flag: "Years of Technology Precipitation",
    flag1: "Over 100 technical team to provide professional services",
    flag2: "Network nodes provide high-speed and stable network",

    c4t1: "Globally Distributed SD-WAN Nodes",
    c4t2: "Intelligent routing enables high availability",

    //底部
    rep: "OceanBlue Cloud",
    rep1: "Copyright © 2021 OceanBlue Cloud. All rights reserved.",
    oshen: "深圳市欧深网络技术有限公司",
    net: "深圳睿网云联科技有限公司",

    // 我们的特点
    feature_t: "Our Features",
    feature_1: "High Performance",
    feature_2: "Strong Security",
    feature_3: "High Reliability",
    feature_4: "Smart Routing",
    feature_5: "Easy to Use",
    feature_6: "Real-time  Monitoring",
    feature_7: "Data Analysis",
    feature_8: "Flexible Deployment",
    feature_d_1:
        "With our FastIP technology, a high bandwidth network will be built between different locations.",
    feature_d_2:
        "High-intensity data encryption technology will ensure privacy during data transmission.",
    feature_d_3: "High availability guarantee with 7*24 service.",
    feature_d_4:
        "An auto-recovered network with decentralized artificial intelligence controller.",
    feature_d_5: "A human friendly management websit for operator.",
    feature_d_6:
        "Monitoring status each second, and raise alarm when problems found.",
    feature_d_7:
        "Dash board with varieties of data, reports and statistics for analysis.",
    feature_d_8:
        "The OBC solutions can be deployed wherever there is Internet access.",
    //content2
    c2_t: "Improve Application Performance by OBC Cloud APP Delivery Service.",
    c2_c:
        "OBC Enterprise cloud SaaS application (Office 365, Salesforce, SAP…) performance will accelerate at least 4 times with OBC cloud delivery service.",
    c2_t1: "Global Enterprise Network with Cloud Connection as a Service",
    c2_c1:
        "It is efficient to set up a private Global Network Connectivity by OBC Cloud Xpress Connect Service.",
    //content3
    c3_t: "Globally Distributed SD-WAN Nodes",
    c3_t1: "Intelligent routing enables high availability",
};

//关于我们
export const ab = {
    aboutUs: "About Us",
    aboutUsCont:
        "We build advanced, stable, high speed, low latency WAN networks to help enterprise users focus on their core business",
    concatUs: "Contact Us",
    who: "About Us",
    whoCont:
        "For decades, companies rely on WAN technologies (e.g. DDN, Frame Relay and MPLS) to transfer business data with high quality. Today, as cloud strucutre and hybrid structure are widely used, and demand for big data and real-time data transmission increases, traditional WAN technology is no longer able to satisfy enterprise customers, who increasingly demand faster responses and more reliable connections.",
    whoCont1:
        "Oceanblue Cloud(ShenZhen Ruiwang Yunlian Technology Co.,Ltd.) reckons that long-distance and high-quality real time data transmission should not be the bottleneck of business development. As such, we relied on our state-of-the-art 'Fastip' technology to help enterprise customers connect to WAN at a faster speed.",
    whoCont2:
        "With our service, customers are able to enjoy ultra-high speed, high quality data transmission service through the Internet or MPLS. In addition, OBC leverages the artificial intelligence technology to redefine the WAN by optimizing network traffic and conducting real-time network health check using distributed cloud control system, which increases the visibility of SLA.",

    bj: "BeiJing · China",
    sz: "ShenZhen · China",
    hk: "HongKong · China",
    suzhou: "Suzhou Industrial Park · China",
    db: "Dubai, U.A.E",
    singapore: "Singapore",
    cd: "ChengDu · China",
    locations: "Locations",
    bjAdd:
        "Room 12G, Building B, Chaowai MEN, No. 26 Chaowai Street, Chaoyang District, Beijing",
    szAdd:
        "Room 601, Building A, Building E2, TCL International E City, Xili Street, Nanshan District, Shenzhen City, Guangdong Province",
    hkAdd:
        "Unit 15B, Gaoming Commercial Building 998 Canton Road, Mong Kok, HongKong",
    suzhouAdd:
        "Xinping Street No. 388, Ascendas iHub, Building 21, 5th Floor, Room 04.",
    cdAdd:
        "Room No.7 F1 Unit 108, Tinafu Avenue, High-tech District, Chengdu, China(Sichuan)Pilot Free Trade Zone",
    sh: "ShangHai · China",
    shAdd:
        "Room 813, Building T2, Jingyao Qiantan, No. 308 Jiangyao Road, Pudong New District, Shanghai",
    us: "CA · USA",
    usAdd: "3230 E IMPERIAL HWY  SUITE 300 BREA, CA 92821, USA",
    jinan: "JiNan · China",
    jinanAdd:
        "Room 1102-04, Tower C, Jinan Taiping Financial Building, Olympic Sports Financial Center, Lixia District, Jinan, Shandong, China",
    flb: "Philippines",
    flbAdd:
        "18th Floor, ORE Central, 31st Street, Taguig, Metro Manila, Philippines",
    bx: "Brazil",
    bxAdd:
        "Av dos Autonomistas4900, galpão C 03.0.0, km 18, Osasco-SP Brasil CEP: 06194-060",
};

//专家团队
export const et = {
    et: "Expert Team",
    zhang: "Alexann Zhang",
    zhangLabel:
        "System analyst and software architect, certified CCIE, MSCE, JNCIS.",
    zhangDesc:
        "1Alexann has over 15 years ICT industry experience, and used to work in Luckypai, Ericsson, Huawei and Etisalat. He was a senior engineer in large-scale network architecture design and enterprise network application troubleshooting.",
    liu: "Yaohua Liu",
    liuLabel: "Network and software architect, R&D expert.",
    liuDesc:
        "Yaohua has early 20 years' experience in R&D as a senior system architect. He worked in Ericsson, Samsung, Nortel and other Fortune 500 companies, and he led a large R&D team in the internet industry in the last few years.",
    wen: "Eddie Wen",
    wenLabel: "",
    wenDesc:
        "Eddie has more than 15 years of international marketing experience across APAC & EMEA. He was a senior engineer in Siemens, and transferred to sales and business development leadership in Huawei.",
    jerry: "Jerry Lee",
    jerryLabel: "IT consultant, CCIE No.9631, CCIE, CCNP, MCSE, certified PMP.",
    jerryDesc:
        "Over years, Jerry Lee has been consulting for global IT business incubation with a variety of technical and business experiences in cutting-edge technologies as a Linux Foundation representative. He used to work for Aryaka Networks, RightScale, Bytemobile, Sylantro System, PacketFront, Datacraft Korea, etc.",
    yan: "Sam Yang",
    yanLabel: "IP network engineer, certified CCIE and JNCIE.",
    yanDesc:
        "Sam was in charge of carrier backbone operation, data center interconnection, enterprise network design and O&M for more than 15 years, he worked in ZTE, Huawei, Alcatel-Lucent, Optus and Telstra.",
    chen: "Lei Chen",
    chenLabel:
        "IP network engineer, Huawei HCIE editorial member and examiner.",
    chenDesc:
        "Chen Lei has worked in Huawei as the IP network global marketing director with 17+ years experience in Telecom and ICT industry, and was in charged of large-scale networks architecture design for VDF, Telefonica, KPN and H3G etc.",
    maggie: "Maggie Liu",
    maggieLabel: "Network architecture consultant.",
    maggieDesc:
        "Maggie has 10+ years experience in telecom and ICT industry, and she was focusing on regional marketing and enterprise network architecture solution in middle east area, also she worked in China Telecom Global and Huawei.",
    long: "Xiulong Zhao",
    longLabel: "Certified CCIE, network engineer.",
    longDesc:
        "Mr.Zhao is senior network engineer with about 15 years experience in network technical support, telecom knowledge training, pre and post sales technical consultant, and customer network project management.",
    quan: "Long Quan",
    quanLabel: "WLAN R&D Director",
    quanDesc:
        "Expert in WLAN SOC and RF design；The industry's most integrated soc wlan module; based on Qualcomm wlan chip independent research and development of 5mhz\\10mhz bandwidth Wi-Fi driver, strong anti-interference.6 years of experience in wlan product development, cooperating with customers in industries such as Fiberhome, hiwifi, and Kangliyoulan to develop and design wlan products.",
    wu: "XiaoXu Wu (Victor)",
    wuLabel: "Senior Network Engineer HCIE-R&S, HCIE-Security",
    wuDesc:
        "Victor Wu has 12 years ICT industry experience, 8 years oversea experience, and used to work in Huawei and Schneider company. He is senior network engineer, responsible for oversea project network design, project delivery and technical support.",
    guo: "Joe Guo",
    guoLabel: "Certified PMP, Data Analyst.",
    guoDesc:
        "Joe Formerly worked in DJI Innovation in managing global key accounts for 3 years, and he is skilled at project management, data analysis and partner training.",
};
//Support
export const sp = {
    download: "Download",
    so: "Service outlets",
    soc: "More than ten years of industry professional service experience",
    soc1: "7x24 hours service hotline",
    soc2: "Technical support covers the world",
    soc3: "R&D center expert team responds quickly",
    //表单
    f_title: "Request Free Trial",
    f_subTitle:
        "Get high-speed and stable Internet connections for your global branches, as well as application acceleration",
    f_first: "First Name",
    f_last: "Last Name",
    f_email: "Email",
    f_com: "Company Name",
    f_region: "Region/Country",
    f_tel: "Phone Number",
    f_other: "Do users encounter global application performance problems?",
    f_yes: "Yes",
    f_not: "No",
    f_more: "Tell us more",
    f_submit: "Submit",
};
//SD-WAN
export const sd = {
    w1: "Why",
    wc:
        "With the enterprise broadband access and Internet backbone network capacity increasing,SD-WAN provides a low-cost network solution based on existing circuits.",
    mt: "Traditional MPLS Private Network",
    mc:
        "For traditional enterprise, applications like email, file-sharing, OA are centralize deployed. The traditional private or MPLS circuit has many limitations: complex deployment, expensive CAPEX/OPEX, and lack of flexibility.Typically, branch offices that locates in different countries connect to headquarter's data center through the private or MPLS circuit, the architecture is shown below",
    tt: "All these limitations can be overcome by SD-WAN solution",
    sdc:
        "SD-WAN employs the control/date plane segregation, centralized management and other SDN conceptions. It helps company to fast deploy WAN network across the world with an easy operation center.",
    ut: "Do you have or are you planning to deploy SD-WAN?",
    w2: "Why OBC SD-WAN?",
    w2c:
        "We build advanced, stable, high speed, low latency WAN network to help enterprise users focus on their core business.",
    c1: "Plug & Play",
    c1c:
        "All the configuration is completed by the OBC cloud controller without any on-site integration",
    c2: "Agile & Lean Deploment",
    c2c: "Zero IT knowledge requirement for customer side",
    c2c1:
        "Support Layer 2/3 connection, no modification to customer's current network topology",
    c3: "Global Coverage",
    c3c: "The OBC solutions can be deployed wherever there is Internet access",
    c4: "On-Demand Paid with OPEX Mode",
    c4c: "Hardware and software free of charge",
    c4c1: "Customer only need to pay for subscription fee",
    c5: "Secure Data Channel",
    c5c:
        "AES256 encryption is deployed by OBC to ensure the security of customer data",
    c6: "Hardware Lifetime Warranty",
    c6c:
        "OBC commits to offer 99.9% availability and free replacement for all hardware",
};

//m100下载
export const m100 = {
    t: "M100 Client Download",
    c1: "Universal client to enable all Oceanblue Cloud Network services",
    c2: "Great using experience on mobile and desktop devices",
    c3:
        "Enjoy network access on any of your devices easy and secure everywhere",
    c4: 'AppStore Search "M100"',
    c5: "Download",
    c6: "click to download",
    t1: "NetTool Client Download",
    c7: "Can diagnose the network status of OBC service",
    n1: "Installation Notes",
    kylin_uos: "KYLIN / UOS",
    ipsec_download: "If you need Ipsec, click to download",
    c8:
        "For HarmonyOS NEXT (5.0.0) and Later Versions, Search for “鸿安通” in the App Gallery to Download.",

    download_title: "Apps Download",
    download_m100: "M100 Client",
    download_tip:
        "The M100 Client supports VPN network access, and users can use multiple operating systems, including IOS, Android, Mac, Windows, Kirin/Unisys, and HarmonyOS",
    download_tip2:
        "E-Connect Client supports VPN network access, and users can use the Android version.",
    download_start: "Go Download",
    download_sase: "SASE Client",
    download_sase_tip:
        "The SASE Client supports zero-trust network access and is available for multiple operating systems including IOS, Android, Mac, Windows, and HarmonyOS",
    download_nt: "NetTool Client ",
    download_nt_tip: "Tools for diagnosing the status of OceanBlue services.",
    download_ipsec: "Download (IPSec)",
    download: "Download",
    download_kylin: "KYLIN/UOS",
    download_development: "Development",
    download_intel_x86: " (Intel X86 Series)",
    download_m: " (Apple M Series)",
    download_type: "Choose the Product Version",
    download_intel: "Download Intel Chip",
    download_intel2: "For Intel x86 Series Chips",
    download_apple: "Download Apple Chip",
    download_apple2: "For Apple M Series Chips",
    download_type_tip: "How to Confirm the Chip Type",
    download_type_tip2:
        "1、In the upper left corner, Open the Apple menu and select “About This Machine”.",
    download_type_tip3:
        "2、Check whether it is “Intel” or “Apple” in “Processor” or “Chip”.",
    download_e_connect: "E-Connect",
    download_qr_title: "Scan QR code to download",
    download_qr_loading: "Generating QR code...",
    harmonyOS_tip: "HarmonyOS NEXT (5.0.0) and Later Versions",
    kylin_install_tip:
        "Before double-clicking to install, please allow third-party software installation in system settings first.",
    kylin_install_how: "How to set?",
    kylin_install_got_it: "Got it",
};

//合作伙伴
export const pa = {
    t: "Cooperate Apply",
    c:
        "Sales Partners are partners who work with OBC on the SDWAN market and sell OBC products, solutions, and services to end customers.",
    c1: "High Performance",
    c2: "Strong Security",
    c3: "High Reliability",
    c4: "Intelligent Routing",
    c5: "Easy to Use",
    c6: "Real-time Monitoring",
    c7: "Data Analysis",
    c8: "Flexible Deployment",
    f1: "Type",
    o1: "Personal",
    o2: "Company",
    f2: "Email",
    f3: "Name",
    f4: "Company Email",
    f5: "Company Name",
    f6: "Type of Business Registration",
    f7: "Others",
    f8: "Username",
    f9: "Phone Number",
    f10: "Region/Country",
    f11: "Front Photo of ID Card",
    f12: "Back Photos of ID Card",
    f13: "Upload",
    f14: "Photo of Business Registration",
    f15: "Submit",
};

//设备
export const dv = {
    //rx
    rxs: "Standard 1U",
    rxu: "Users",
    rxesim: "Built-in esim",
    rxno: "N/A",
    rxv100: "According to cloud configuration",
    rxv100a: "Cloud Virtual image",
    rxv100u: "Public Cloud/Private Cloud",
    rxv100t: "Virtual device",
    rxv100t1: "Virtual Edge Connector",
    rxv100t2: "Applicable public cloud private cloud platform",
    //r200
    rt: "Standard 1U Carrier Level Device",
    rt1: "High Performance Device with Gigabits Interfaces",
    rt2: "Powerful Network Device",
    rd: "RAM",
    rd1: "Operational Ability",
    rd2: "Forwarding Ability",
    rd3: "Size",
    rd4: "Interface",
    rsk: "CISCO Standard Serial",
    ry: "Scenario",
    ryc: "Corporate Headquarter",
    ryc1: "Large Company Branch",
    ru: "Number",
    ruc: "10-300 Users",
    ra: "Installation",
    rac: "1U Standard Rack",
    //d100
    dtt: "High-performance small and medium-sized equipment",
    dt1: "Desktop Edge Connector",
    dt2: "High Network Forwarding Ability,Stable and Reliable",
    duc: "10-50 Users",
    dac: "Desktop/Wall Hanging",
    ds: "Serial",
    dy: "Small and Medium-sized Company",
    //S200
    st: "Intelligent Network Device with LTE Function",
    st1: "High WIFI Ability",
    st2: "Support Global LTE as WAN Connection",
    sg: "Global",
    sy: "Small Company Branch",
    sy1: "Retail Store",
    suc: "5-30 Users",
    //S50
    s5t: "Smart Size with Powerful Function",
    s5t1: "Perfect Fits for Small and Medium Level",
    s5t2: "Network Deployment",
    s5p: "Power Supply",
    s5u: "Less than 30 Users",
    //a55
    at: "Personal Device with Global Data Roaming",
    at1: "Global E-SIM, Multi-Color",
    at2: "Smart Mobile Device for Global Business Man",
    aic: "Global LTE (Built in E-SIM)",
    auc: "Soho",
    anc: "Less than 5 Users",
    aic: "Desktop/Mobile",
    //比较
    dt: "Comparison",
    dn: "Name",
    das: "Application Scenario",
    dcn: "Number of Customers",
};

//企业
export const ep = {
    t: "Enterprise IT services are gradually migrating to hybrid cloud",
    c:
        "There are relatively mature solutions for business virtualization, but the network connection only completes the local area network virtualization, and the WAN connection remains in the traditional mode. WAN connection virtualization requires data control, which is oriented toward unified management, scheduling, and configuration, and data forwarding is oriented toward resource concentration and sharing.",
    t1:
        "Wide area network deployment based on SD WAN architecture to assist enterprise hybrid networking",
    c1:
        "Through multi-type SD-WAN CPE, connect to the cloud POP point via the Internet, realize fast, convenient, high-quality, low-cost hybrid networking. Support the smooth evolution of traditional WAN networking to SD-WAN, protect existing investments and business consistency, and help enterprise data centers to gradually migrate to the cloud.",
    t2: "SD-WAN Cloud Express Solution-Smart WAN",
    c2:
        "Enterprise cross-border networking between domestic and foreign branches/branch offices/customer headquarters/data centers, corresponding to dedicated lines or MPLS, to achieve high-speed and low-latency hybrid cloud interconnection with domestic 3-layer connections. It is recommended that each channel of high-definition conferences use 4M and above bandwidth , After the company’s internal networking, all data is transmitted on the internal network, AES256 encryption can ensure data security, support hybrid networking, make full use of existing investments, support low-cost expansion, SD-WAN centralized control system, configuration and security strategies can be combined Unified push to all access points.",
    kt: "Lower The Cost",
    kt1: "High Quality",
    kt2: "Express Delivery",
    kt3: "Easy To Manage",
    kt4: "High Availability",
    kt5: "Flexibility",
    kc:
        "Compared with the existing MPLS/dedicated line solution, the cost and TCO are reduced by 80%",
    kc1:
        "The overall network is based on SD-WAN technology, but the national backbone adopts optical fiber transmission (non-public network), which can effectively ensure line stability, and all connections (including institutions below the provincial level) can achieve line quality similar to MPLS",
    kc2: "Open business within one week, zero configuration of branches",
    kc3:
        "Unified management and configuration of global branches and unified monitoring of network conditions",
    kc4: "All branches adopt the master-backup solution",
    kc5:
        "Compared with MPLS/dedicated line, it has stronger virtualization capabilities and supports richer and faster networking solutions",
};

//多点组网
export const vn = {
    t: "Virtual Network solution",
    c:
        "Office points only need to be connected to the public network to form a network. Branch areas are directly connected to SD-WAN backbone access points through dedicated lines or broadband. The Northwest region uses FastIP technology to optimize public network transmission and then connects to Central China access points or cloud relays. Point, the province uses FastIP technology to optimize public network transmission and then directly connects to the headquarters, supporting equipment and link-level active-standby or dual-active mode.",
    cc:
        "No need to change the existing system architecture, no need to invest in any fixed assets in advance, save construction and maintenance costs, optimize transmission quality through algorithms without increasing costs, fast deployment cycle, unified visual management of the entire network, support for hybrid networking, and fully Use existing resources and AES-256 strong encryption to ensure the security of customer data.",
    t1: "Branch storefront network architecture",
    c1:
        "Support multiple access modes, LTE, broadband and MPLS. Supports different user volumes based on different types of equipment used by various branches. Branch stores use S/D series equipment. The headquarters uses R equipment.",
    u1: "50 to 300 Users",
    u2: "50 to 50 Users",
    u3: "5 to  30 Users",
};

//云快递
export const csa = {
    t: "OBC Cloud SaaS Acceleration improves Office 365 performance",
    c:
        "With the continuous improvement of enterprise broadband access and Internet backbone network capacity, the OBC Cloud SaaS Acceleration service can significantly improve the operational smoothness of Office365. Based on the existing lines, SD-WAN provides the low-cost network connection method sought by the industry. The network architecture deployment is shown in the following figure:",
    t1: "OBC Cloud SaaS Acceleration improves the application experience",
    c1:
        "Each branch has deployed OBC edge connectors to connect to the OBC Cloud SaaS Acceleration service. The OBC Cloud SaaS Acceleration network accelerates the process of data transmission to the Office 365 cloud server. The OBC Cloud Express network uses low-latency network technology to significantly improve Application experience.",
};

//云快线
export const cxc = {
    t: "Cloud Xpress Connect",
    t1: "OBC cloud connection covers between edge connectors",
    c:
        "Provide cloud connectivity between headquarters and private cloud nodes",
    c1: "Provide cloud connectivity between branches and public cloud nodes",
    c2: "Provide cloud connectivity between headquarters and branches",
    c3:
        "Realize high-speed and low-latency transport layer second or third layer cross-border connections",
};
//全球应用发布
export const gaa = {
    c:
        "Based on OBC's global distribution nodes, publish your website to any country or region, thereby increasing the speed of your website's global access",
    c1:
        "At the same time, it supports the acceleration of static resources and dynamic data interfaces, which is better than CDN",
    c2:
        "After using the service, the Internet speed can be achieved when doing cross-border access between different countries",
    c3: "A hundredfold increase",
};
//移动应用
export const mob = {
    t:
        "Multi-platform client application to improve the efficiency of mobile office and remote office",
    c:
        "We have multi-platform client programs such as windows, mac, android, ios, etc., which can use the universal client of all services of Europe-Shenzhen, and can support all mainstream mobile and desktop devices, and can enjoy safe and convenient network access through any device",
    f:
        "After using the service, you can do cross-border high-speed access between different countries",
    f1: "Support multiple desktop and mobile systems",
    f2: "One-click login high-speed and secure encrypted link",
    f3: "Support seamless docking of corporate accounts",
    c1: "Go to download",
};



// WEBPACK FOOTER //
// ./src/assets/lang/en.js